import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "as-popup__result-content" }
const _hoisted_2 = { class: "as-popup__result-header" }
const _hoisted_3 = { class: "as-popup__result-competition" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "as-match-as-competition__name" }
const _hoisted_6 = { class: "as-popup__result-body" }
const _hoisted_7 = { class: "as-popup__result-team-info as-popup__result-team-info-new" }
const _hoisted_8 = { class: "as-time as-flex as-text-center" }
const _hoisted_9 = { class: "as-info as-flex as-text-center" }
const _hoisted_10 = { class: "as-team-home" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "as-team-name" }
const _hoisted_13 = { class: "as-score" }
const _hoisted_14 = { class: "as-popup__result-score" }
const _hoisted_15 = { class: "as-team-away" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "as-team-name" }
const _hoisted_18 = { class: "as-result as-flex as-text-center" }
const _hoisted_19 = { class: "as-popup__result-half-time-score" }
const _hoisted_20 = { class: "as-as-popup-item as-as-popup-item__result-half" }
const _hoisted_21 = { class: "as-score-value" }
const _hoisted_22 = {
  key: 0,
  class: "as-as-popup-item as-as-popup-item__first-leg"
}
const _hoisted_23 = { class: "as-score-value" }
const _hoisted_24 = {
  key: 1,
  class: "as-as-popup-item as-as-popup-item__total-scores"
}
const _hoisted_25 = { class: "as-score-value" }
const _hoisted_26 = { class: "as-popup__result-tab-content" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { key: 3 }
const _hoisted_31 = { key: 4 }

import { reactive, ref, watch, watchEffect, onMounted, computed } from "vue";
import IncidentsList from "~src/components/incidents/IncidentsList.vue";
import StatisticsList from "~src/components/statistics/StatisticsList.vue";import H2hList from "~src/components/h2h/H2hList.vue";
import StandingList from "~src/components/standings/StandingList.vue";
import StandingListTab from "~src/components/standings/StandingListTab.vue";
import Lineups from "~src/components/lineups/Lineups.vue";
import ScoreVs from "~src/components/matches/ScoreVs.vue";
import StatsBtn from "~src/components/matches/StatsBtn.vue";
import IconStats from "~src/components/icons/menus/IconStats.vue";
import IconSummary from "~src/components/icons/menus/IconSummary.vue";
import IconLineUp from "~src/components/icons/menus/IconLineUp.vue";
import IconStanding from "~src/components/icons/menus/IconStanding.vue";
import IconH2h from "~src/components/icons/menus/IconH2h.vue";
import TabsIcon from "~src/components/TabsIcon.vue";
import IncidentsListSkeleton from "~src/components/skeleton/result-popup/IncidentsListSkeleton.vue";
import StatisticsListSkeleton from "~src/components/skeleton/result-popup/StatisticsListSkeleton.vue";
import H2hListSkeleton from "~src/components/skeleton/result-popup/H2hListSkeleton.vue";
import LineupTabSkeleton from "~src/components/skeleton/result-popup/LineupTabSkeleton.vue";
import StandingListSkeleton from "~src/components/skeleton/standing/StandingListSkeleton.vue";

import {
  matchIncidents,
  matchStatistics,
  matchH2h,
  matchStanding,
  matchLineups,
} from "~src/services/SpapiService";
import MatchEnum from "~src/enums/MatchEnum";
import type { IMatch, ICompetitions } from "~src/interfaces";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import {
  getTeamNameShow,
  getCompetitionNameShow
} from "~src/helpers";
import AsPopup from "~src/components/AsPopup.vue";
import { useIsMobile } from "~src/utils/isMobile";
import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface IProps {
  visible: boolean;
  match: IMatch;
  competition: ICompetitions;
  incidents: Array<Object>;
  isShowPopup: boolean;
  isStandingTab?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'PopupComponent',
  props: {
    visible: { type: Boolean },
    match: {},
    competition: {},
    incidents: { default: () => [] },
    isShowPopup: { type: Boolean },
    isStandingTab: { type: Boolean, default: false }
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {

;
const commonStore = usecommonStore();

const emits = __emit;

const props = __props;

const isMobile = ref(useIsMobile());
const siteName = computed(() => commonStore.getSiteName);

const competitionName = computed(() => getCompetitionNameShow(props.competition || props.match.competition));

// check trường hợp trận chưa kết thúc lượt đi chưa cộng vs lượt về
const isAggScoreTotal = computed(() => {
  return parseInt(props.match.agg_score[0]) - props.match.home_scores[0] >= 0
    && parseInt(props.match.agg_score[1]) - props.match.away_scores[0] >= 0
});

const isOvertimeScore  = computed(() => {
  return props.match.home_scores[5] > 0 || props.match.away_scores[5] > 0;
});

const firstLegScore  = computed(() => {
  let home = 0;
  let away = 0;
  if(isAggScoreTotal.value) {
    if(isOvertimeScore.value) {
      home =  props.match.agg_score[0] - props.match.home_scores[5];
      away =  props.match.agg_score[1] - props.match.away_scores[5];
    } else {
      home =  props.match.agg_score[0] - props.match.home_scores[0];
      away =  props.match.agg_score[1] - props.match.away_scores[0];
    }
  } else {
    home =  props.match.agg_score[0];
    away =  props.match.agg_score[1];
  }

  return {
    home,
    away
  }
});

const tabs = [
  {
    key: "overview",
    title: "Tổng Quan",
    icon: IconSummary,
  },
  {
    key: "statistics",
    title: "Thống Kê",
    icon: IconStats,
  },
  {
    key: "h2h",
    title: "Đối đầu",
    icon: IconH2h,
  },
  {
    key: "lineups",
    title: "Đội hình",
    icon: IconLineUp,
  },
  {
    key: "standing",
    title: "Bảng xếp hạng",
    icon: IconStanding,
  },
];

const activeTab = ref("overview");
const incidents = ref([]);
const statistics = ref([]);
const h2h = ref(null);
const standing = ref(null);
const lineups = ref(null);

const fetchedStatus = reactive<Record<string, boolean>>({});

const toggle = () => {
  emits("toggle");
};

watchEffect(() => {
  document.body.style.overflow = props.isShowPopup ? "hidden" : "auto";
});

onMounted(() => {
  changeTab("overview");
});

const changeTab = (tabName: string) => {
  activeTab.value = tabName;
  const matchId = props.match.id;
  const seasonId = props.match.season_id;
  if (!fetchedStatus[tabName]) {
    if (tabName === "statistics") {
      matchStatistics(matchId).then((response) => {
        statistics.value = response.data.data;
      }).finally(() => {
        fetchedStatus[tabName] = true;
      });
    } else if (tabName === "overview") {
      matchIncidents(matchId).then((response) => {
        incidents.value = response.data.data;
      }).finally(() => {
        fetchedStatus[tabName] = true;
      });
    } else if (tabName === "h2h") {
      if (!h2h.value) {
        matchH2h(matchId).then((response) => {
          h2h.value = response.data.data;
        }).finally(() => {
          fetchedStatus[tabName] = true;
        });
      }
    } else if (tabName === "standing") {
      if (!standing.value) {
        matchStanding(seasonId).then((response) => {
          standing.value = response.data.data;
        }).finally(() => {
          fetchedStatus[tabName] = true;
        });
      }
    } else if (tabName === "lineups") {
      if (!lineups.value) {
        matchLineups(matchId).then((response) => {
          lineups.value = response.data.data;
        }).finally(() => {
          fetchedStatus[tabName] = true;
        });
      }
    }
  }
};

const getStatusName = (str: keyof typeof MatchEnum.MATCH_STATUS_TEXT) => {
  return MatchEnum.MATCH_STATUS_TEXT[str];
};

const homeScores = props.match.home_scores || [];
const awayScores = props.match.away_scores || [];

const homeScore = computed(() => {
  let score = props.match.home_scores[0];

  // Trường hợp đá hiệp phụ
  if (homeScores[5] > 0) {
    score = homeScores[5];

    return score;
  }

  return score;
});

const awayScore = computed(() => {
  let score = awayScores[0];

  // Trường hợp đá hiệp phụ
  if (awayScores[5] > 0) {
    score = awayScores[5];

    return score;
  }

  return score;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AsPopup, {
    title: "KQBD",
    wrapClass: "as-popup__result-wrap",
    popupClass: `as-popup__result as-popup__result-${siteName.value}`,
    isShowPopup: _ctx.isShowPopup,
    isShowHeader: false,
    onToggle: toggle
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.getImgUrlBySport('competition', _ctx.match.competition_id),
              alt: competitionName.value,
              class: "as-lazyload as-match-as-competition__logo img-fluid"
            }, null, 8, _hoisted_4),
            _createElementVNode("span", _hoisted_5, _toDisplayString(competitionName.value), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "as-popup__result-close-btn",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle', false)))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(formatLocalTime)(_ctx.match.match_time, "h:mm DD/MM")), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: _ctx.getImgUrlBySport('team', _ctx.match.home_team?.id),
                  alt: _unref(getTeamNameShow)(_ctx.match.home_team),
                  class: "as-lazyload as-popup__result-team-logo"
                }, null, 8, _hoisted_11),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(getTeamNameShow)(_ctx.match.home_team)), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(ScoreVs, {
                    match: _ctx.match,
                    modifyClass: "is-popup"
                  }, null, 8, ["match"])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("img", {
                  src: _ctx.getImgUrlBySport('team', _ctx.match.away_team?.id),
                  alt: _unref(getTeamNameShow)(_ctx.match.away_team),
                  class: "as-lazyload as-popup__result-team-logo"
                }, null, 8, _hoisted_16),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(getTeamNameShow)(_ctx.match.away_team)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[1] || (_cache[1] = _createTextVNode(" Kết quả hiệp 1: ")),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.match.home_scores[1]) + " - " + _toDisplayString(_ctx.match.away_scores[1]), 1)
                ]),
                (_ctx.match.leg && _ctx.match.leg === 'Second Leg' && _ctx.match.agg_score && _ctx.match.agg_score.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _cache[2] || (_cache[2] = _createTextVNode(" Lượt đi: ")),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(firstLegScore.value.home) + " - " + _toDisplayString(firstLegScore.value.away), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.match.leg && _ctx.match.leg === 'Second Leg' && _ctx.match.agg_score && _ctx.match.agg_score.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _cache[3] || (_cache[3] = _createTextVNode(" Tổng tỉ số: ")),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(isAggScoreTotal.value ? _ctx.match.agg_score[0] : parseInt(_ctx.match.agg_score[0]) + _ctx.match.home_scores[0]) + " - " + _toDisplayString(isAggScoreTotal.value ? _ctx.match.agg_score[1] : parseInt(_ctx.match.agg_score[1]) + _ctx.match.away_scores[0]), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(StatsBtn, { match: _ctx.match }, null, 8, ["match"])
            ])
          ]),
          _createVNode(TabsIcon, {
            tabs: tabs,
            activeTab: activeTab.value,
            isShowName: true,
            isShowBorderTop: true,
            onChange: changeTab
          }, null, 8, ["activeTab"]),
          _createElementVNode("div", _hoisted_26, [
            (activeTab.value === 'overview')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createVNode(_Transition, {
                    name: "as-fade",
                    mode: "out-in"
                  }, {
                    default: _withCtx(() => [
                      (fetchedStatus.overview)
                        ? (_openBlock(), _createBlock(IncidentsList, {
                            key: 0,
                            match: _ctx.match,
                            incidents: incidents.value
                          }, null, 8, ["match", "incidents"]))
                        : (_openBlock(), _createBlock(IncidentsListSkeleton, { key: 1 }))
                    ]),
                    _: 1
                  })
                ]))
              : (activeTab.value === 'statistics')
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(_Transition, {
                      name: "as-fade",
                      mode: "out-in"
                    }, {
                      default: _withCtx(() => [
                        (fetchedStatus.statistics)
                          ? (_openBlock(), _createBlock(StatisticsList, {
                              key: 0,
                              match: _ctx.match,
                              statistics: statistics.value
                            }, null, 8, ["match", "statistics"]))
                          : (_openBlock(), _createBlock(StatisticsListSkeleton, { key: 1 }))
                      ]),
                      _: 1
                    })
                  ]))
                : (activeTab.value === 'h2h')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createVNode(_Transition, {
                        name: "as-fade",
                        mode: "out-in"
                      }, {
                        default: _withCtx(() => [
                          (fetchedStatus.h2h)
                            ? (_openBlock(), _createBlock(H2hList, {
                                key: 0,
                                match: _ctx.match,
                                h2h: h2h.value
                              }, null, 8, ["match", "h2h"]))
                            : (_openBlock(), _createBlock(H2hListSkeleton, { key: 1 }))
                        ]),
                        _: 1
                      })
                    ]))
                  : (activeTab.value === 'standing')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createVNode(_Transition, {
                          name: "as-fade",
                          mode: "out-in"
                        }, {
                          default: _withCtx(() => [
                            (fetchedStatus.standing && !_ctx.isStandingTab)
                              ? (_openBlock(), _createBlock(StandingList, {
                                  key: 0,
                                  match: _ctx.match,
                                  standing: standing.value
                                }, null, 8, ["match", "standing"]))
                              : (fetchedStatus.standing && _ctx.isStandingTab)
                                ? (_openBlock(), _createBlock(StandingListTab, {
                                    key: 1,
                                    match: _ctx.match,
                                    standing: standing.value,
                                    isShowFull: !isMobile.value,
                                    hideShowFull: !isMobile.value
                                  }, null, 8, ["match", "standing", "isShowFull", "hideShowFull"]))
                                : (_openBlock(), _createBlock(StandingListSkeleton, { key: 2 }))
                          ]),
                          _: 1
                        })
                      ]))
                    : (activeTab.value === 'lineups')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createVNode(_Transition, {
                            name: "as-fade",
                            mode: "out-in"
                          }, {
                            default: _withCtx(() => [
                              (fetchedStatus.lineups)
                                ? (_openBlock(), _createBlock(Lineups, {
                                    key: 0,
                                    match: _ctx.match,
                                    lineups: lineups.value
                                  }, null, 8, ["match", "lineups"]))
                                : (_openBlock(), _createBlock(LineupTabSkeleton, { key: 1 }))
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["popupClass", "isShowPopup"]))
}
}

})